import { forwardRef } from 'react';
import { clsx } from 'clsx';

import type { CSSProperties } from 'react';
import type { MaintenanceMessage } from 'types/__generated__';

import styles from './AppStatusBar.module.css';

import { useScrollableHeader } from 'providers/ScrollableHeaderProvider';

export type Ref = HTMLDivElement;

interface AppStatusBarProps extends MaintenanceMessage {
  appStatusBarHeight: number;
}

export const AppStatusBar = forwardRef<Ref, AppStatusBarProps>((appStatusBarProps, ref) => {
  const { severity, message, appStatusBarHeight } = appStatusBarProps;
  const { classNameSuffix, animationClass } = useScrollableHeader();

  return (
    <div
      className={clsx(
        styles['app-status-bar'],
        styles[`app-status-bar--${severity.toLowerCase()}`],
        styles[`app-status--${classNameSuffix}`],
        animationClass && styles[`app-status--${animationClass}`]
      )}
      style={
        {
          '--app-status-bar-height': `${appStatusBarHeight}px`,
        } as CSSProperties
      }
      ref={ref}
    >
      <p className={styles['app-status-bar__message']} dangerouslySetInnerHTML={{ __html: message }} />
    </div>
  );
});
